/**
 * v0.22.3 B5 (ADR-122; Q2 = A) — việc thuần của "hỏi lại một lần trước khi lưu thay đổi làm tiệm hết nhận khách".
 *
 * Máy chủ không chặn hẳn (ADR-096 Q2: nghỉ việc người cuối hay tạm ngừng bán là việc thật) mà trả 409 `TIEM_SE_NGUNG_NHAN` kèm các vế sẽ
 * mất; chỉ khi gửi lại kèm `xacNhanNgungNhan: true` mới lưu. Giao diện hỏi bằng tờ `HoiNgungNhan` (file riêng, có React).
 */
import { ApiFailure } from './api.ts'
import { T } from './text/vi.ts'

/** Lỗi nào là "tiệm sẽ ngừng nhận khách"? */
export function laLoiNgungNhan(e: unknown): e is ApiFailure {
  return e instanceof ApiFailure && e.code === 'TIEM_SE_NGUNG_NHAN'
}

/**
 * Câu hỏi theo vế mất. Nhiều vế cùng mất thì nói vế GỐC: chi nhánh hết giờ mở cửa > tắt dịch vụ cuối (kéo theo hết người nhận khách) >
 * hết người nhận khách.
 */
export function cauHoiNgungNhan(mat: readonly string[]): string {
  if (mat.includes('gio-mo-cua')) return T.stopNoHours
  if (mat.includes('dich-vu')) return T.stopNoService
  return T.stopNoStaff
}

export type KetQuaLuu<R> = { ket: 'luu'; gia: R } | { ket: 'thoi' }

/**
 * Lưu có hỏi lại. `goi(undefined)` là lần đầu; nếu máy chủ trả `TIEM_SE_NGUNG_NHAN`, `hoi(mat)` hiện tờ và trả `true` khi chủ tiệm bấm
 * "Vẫn lưu" (gửi lại `goi(true)`), `false` khi "Thôi, để như cũ" (không gửi gì). Lỗi khác ném nguyên; lần gửi lại có lỗi cũng ném (không
 * hỏi vòng nữa).
 */
export async function luuCoHoiLai<R>(
  goi: (xacNhan: true | undefined) => Promise<R>,
  hoi: (mat: readonly string[]) => Promise<boolean>,
): Promise<KetQuaLuu<R>> {
  try {
    return { ket: 'luu', gia: await goi(undefined) }
  } catch (e) {
    if (!laLoiNgungNhan(e)) throw e
    if (!(await hoi(e.matKhiLuu))) return { ket: 'thoi' }
    return { ket: 'luu', gia: await goi(true) }
  }
}
